import mixin_calculators from "@/calculators/mixin.calculators.js";
const changeVariableDisplay = mixin_calculators.changeVariableDisplay;
const IRIS_PARAMETERS = {
    "dogsSerumCreatinine": [
        '<1,4 mg/dL',
        '1,4 – 2,8 mg/dL',
        '2,9 – 5 mg/dL',
        '>5 mg/dL',
    ],
    "dogsSdma": [
        '<18 mcg/dL',
        '18 – 35 mcg/dL',
        '36 – 54 mcg/dL',
        '>54 mcg/dL'
    ],
    "dogsUpc": [
        '<0,2',
        '0,2 – 0,5',
        '>0,5',
    ],
    "catsSerumCreatinine": [
        '<1,6 mg/dL',
        '1,6 – 2,8 mg/dL',
        '2,9 – 5 mg/dL',
        '>5 mg/dL',
    ],
    "catsSdma": [
        '<18 mcg/dL',
        '18 – 25 mcg/dL',
        '26 – 38 mcg/dL',
        '>38 mcg/dL'
    ],
    "catsUpc": [
        '<0,2',
        '0,2 – 0,4',
        '>0,4',
    ],
    "systolicBloodPressure": [
        '<140 mmHg',
        '140 – 159 mmHg',
        '160 – 179 mmHg',
        '⩾ 180 mmHg',
    ],
}
export default {
    name: 'Estadiamento IRIS | Doença Renal Crônica',
    id: 'cd6918d432c64a66a1ebfc85e39f680e',
    classes: ['Escalas | Escores'],
    premium: true,
    mounted() {
        changeVariableDisplay("dogsSerumCreatinine", false);
        changeVariableDisplay("dogsSdma", false);
        changeVariableDisplay("dogsUpc", false);
        changeVariableDisplay("catsSerumCreatinine");
        changeVariableDisplay("catsSdma");
        changeVariableDisplay("catsUpc");
    },
    variables: [
        {
            name: 'Selecione o paciente',
            type: 'select-animal',
            placeholder: 'Selecione',
            id: 'animal',
            items: [
                'dog',
                'cat',
            ],
            change: function (val) {
                changeVariableDisplay("dogsSerumCreatinine", val != 0);
                changeVariableDisplay("dogsSdma", val != 0);
                changeVariableDisplay("dogsUpc", val != 0);
                changeVariableDisplay("catsSerumCreatinine", val == 0);
                changeVariableDisplay("catsSdma", val == 0);
                changeVariableDisplay("catsUpc", val == 0);
            },
            default: 0
        },
        {
            name: 'Creatinina Sérica (mg/dL)',
            type: 'select',
            clearable: true,
            placeholder: 'Selecione',
            id: 'dogsSerumCreatinine',
            items: IRIS_PARAMETERS.dogsSerumCreatinine,
            default: null,
        },
        {
            name: 'SDMA (mcg/dL)',
            type: 'select',
            clearable: true,
            placeholder: 'Selecione',
            id: 'dogsSdma',
            items: IRIS_PARAMETERS.dogsSdma,
            default: null
        },
        {
            name: 'UP/C',
            type: 'select',
            clearable: true,
            placeholder: 'Selecione',
            id: 'dogsUpc',
            items: IRIS_PARAMETERS.dogsUpc,
            default: null
        },
        {
            name: 'Creatinina Sérica (mg/dL)',
            type: 'select',
            clearable: true,
            placeholder: 'Selecione',
            id: 'catsSerumCreatinine',
            items: IRIS_PARAMETERS.catsSerumCreatinine,
            default: null,
        },
        {
            name: 'SDMA (mcg/dL)',
            type: 'select',
            clearable: true,
            placeholder: 'Selecione',
            id: 'catsSdma',
            items: IRIS_PARAMETERS.catsSdma,
            default: null
        },
        {
            name: 'UP/C',
            type: 'select',
            clearable: true,
            placeholder: 'Selecione',
            id: 'catsUpc',
            items: IRIS_PARAMETERS.catsUpc,
            default: null
        },
        {
            name: 'Pressão Arterial Sistólica (mmHg)',
            type: 'select',
            clearable: true,
            placeholder: 'Selecione',
            id: 'systolicBloodPressure',
            items: IRIS_PARAMETERS.systolicBloodPressure,
            default: null
        },
    ],
    calculate: function ({ animal, dogsSerumCreatinine, dogsSdma, dogsUpc, catsSerumCreatinine, catsSdma, catsUpc, systolicBloodPressure }) {
        let serumCreatinine = animal == 0 ? dogsSerumCreatinine : catsSerumCreatinine;
        let sdma = animal == 0 ? dogsSdma : catsSdma;
        let upc = animal == 0 ? dogsUpc : catsUpc;
        if (!serumCreatinine && !sdma) {
            return;
        }
        const animalPrefix = { 0: 'dogs', 1: 'cats' }[animal];
        const serumCreatinineLevel =
            IRIS_PARAMETERS[`${animalPrefix}SerumCreatinine`].indexOf(serumCreatinine) + 1;
        const sdmaLevel =
            IRIS_PARAMETERS[`${animalPrefix}Sdma`].indexOf(sdma) + 1;
        const upcLevel =
            IRIS_PARAMETERS[`${animalPrefix}Upc`].indexOf(upc);
        const systolicBloodPressureLevel =
            IRIS_PARAMETERS['systolicBloodPressure'].indexOf(systolicBloodPressure);
        let response = { type: 'multiple', values: [] };
        const irisResponseDescription = 'Estágio IRIS | Doença Renal Crônica:';
        let irisResponseLevel = "";
        if (!serumCreatinineLevel || !sdmaLevel) {
            irisResponseLevel = serumCreatinineLevel + sdmaLevel;
        } else {
            irisResponseLevel = sdmaLevel > serumCreatinineLevel ? (serumCreatinineLevel + 1) : serumCreatinineLevel;
        }
        response.values.push({ description: irisResponseDescription, value: irisResponseLevel.toString() });
        if (upcLevel > -1) {
            response.values.push({
                description: 'Subestadiamento | Proteinúria',
                value: ['Não Proteinúrico', 'Borderline Proteinúrico', 'Proteinúrico'][upcLevel]
            });
        }
        if (systolicBloodPressureLevel > -1) {
            response.values.push({
                description: 'Subestadiamento | Pressão Arterial Sistólica',
                value: [
                    'Normotenso | Mínimo Risco de Lesão de Órgãos-Alvo',
                    'Pré-Hipertenso | Baixo Risco de Lesão de Órgãos-Alvo',
                    'Hipertenso | Moderado Risco de Lesão de Órgãos-Alvo',
                    'Gravemente Hipertenso | Alto Risco de Lesão de Órgãos-Alvo'
                ][systolicBloodPressureLevel]
            });
        }
        return response;
    },
    responseLabel: "Resultados",
    sections: [
        {
            "description": "Objetivos da Calculadora ",
            "objects": [
                {
                    "description": "Estadiamento ",
                    "objects": [
                        {
                            "objects": [
                                {
                                    "description": "O estadiamento é uma ferramenta útil para auxiliar o direcionamento do tratamento e acompanhamento do paciente."
                                }
                            ],
                            "description": "Estadiar e subestadiar pacientes com doença renal crônica conforme os critérios da IRIS (International Renal Interest Society)."
                        }
                    ]
                },
                {
                    "objects": [
                        {
                            "description": "O estadiamento tem algumas premissas:",
                            "objects": [
                                {
                                    "description": "A creatinina sérica e o SDMA devem ser coletados quando o paciente estiver em jejum e hidratado."
                                },
                                {
                                    "description": "Pelo menos duas coletas devem ser realizadas em momentos distintos, para avaliar a consistência do resultado."
                                }
                            ]
                        },
                        {
                            "objects": [
                                {
                                    "description": "O UP/C deve ser avaliado apenas quando não houver indícios de inflamação no trato urinário, hemorragias e disproteinemias."
                                },
                                {
                                    "description": "Pelo menos duas coletas devem ser realizadas, com pelo menos 2 semanas de diferença, para avaliar a consistência do resultado."
                                }
                            ],
                            "description": "Subestadiamento | Proteinúria:"
                        },
                        {
                            "objects": [
                                {
                                    "description": "A mensuração da pressão arterial sistólica deve ser repetida múltiplas vezes, preferencialmente em dias distintos. Caso não seja possível o retorno em dias distintos, mantenha o paciente em ambiente calmo por 2 horas e mensure a pressão novamente."
                                }
                            ],
                            "description": "Subestadiamento | Pressão Arterial Sistólica "
                        }
                    ],
                    "description": "Pontos Importantes "
                }
            ]
        }
    ],
    references: [
        {
            "year": "2019",
            "level": "Não se aplica.",
            "magazine": "Guideline",
            "name": "IRIS Staging of CKD (2019)",
            "link": "http://www.iris-kidney.com/guidelines/staging.html"
        }
    ],
}